// src/data/comedians/ali-wong.js

const base = {
  id: 'ali-wong',
  slug: 'ali-wong',
  name: 'Ali Wong',
  birthYear: 1982,
  image: require('@/assets/images/img_Ali_Wong.jpg'),
  famousWorks: [
    'Baby Cobra (2016)',
    'Hard Knock Wife (2018)',
    'Don Wong (2022)',
    'Beef (2023)',
    'Always Be My Maybe (2019)',
    'American Housewife',
    'Dear Girls (book)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Groundbreaking and unapologetically honest',
    bio: `Ali Wong is an American comedian and actress who broke barriers with her bold, unapologetic comedy about pregnancy, motherhood, marriage, and female sexuality. Her groundbreaking Netflix special "Baby Cobra," performed while seven months pregnant, became a cultural phenomenon and redefined what mainstream comedy could address.\n\nBorn in San Francisco to a Vietnamese mother and Chinese-American father, Wong studied Asian American Studies at UCLA before moving to New York to pursue stand-up comedy. She spent years performing at clubs and appearing in television shows before her breakthrough Netflix specials.\n\nWong's comedy is refreshingly honest about topics often considered taboo, presented with confidence and sharp wit. Beyond stand-up, she has starred in romantic comedy films, written a bestselling book, and created the Netflix series "Beef," which earned critical acclaim and multiple Emmy Awards.`,
    style: 'Bold, honest, feminist perspective, taboo-breaking humor',
    achievements: [
      'Emmy Awards for Beef',
      'Golden Globe Award',
      'New York Times bestselling author',
      'Time 100 most influential people',
      'Breakthrough Netflix specials',
      'Critical acclaim for acting and writing',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américaine',
    shortBio: 'Pionnière et honnêteté assumée',
    bio: `Ali Wong est une comédienne et actrice américaine qui a brisé les barrières avec sa comédie audacieuse et décomplexée sur la grossesse, la maternité, le mariage et la sexualité féminine. Son spécial Netflix révolutionnaire "Baby Cobra", réalisé alors qu'elle était enceinte de sept mois, est devenu un phénomène culturel.\n\nNée à San Francisco d'une mère vietnamienne et d'un père américain d'origine chinoise, Wong a étudié les études américano-asiatiques à l'UCLA avant de s'installer à New York pour poursuivre la comédie stand-up.\n\nLa comédie de Wong est d'une honnêteté rafraîchissante sur des sujets souvent considérés comme tabous, présentée avec confiance et un esprit vif. Au-delà du stand-up, elle a joué dans des films de comédie romantique, écrit un livre best-seller et créé la série Netflix "Beef", acclamée par la critique.`,
    style: 'Audacieuse, honnête, perspective féministe, humour brise-tabous',
    achievements: [
      'Emmy Awards pour Beef',
      'Golden Globe Award',
      'Auteure de best-sellers du New York Times',
      'Time 100 personnalités les plus influentes',
      'Specials Netflix révolutionnaires',
      'Acclamation critique pour le jeu et l\'écriture',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americana',
    shortBio: 'Pionera y honestidad sin disculpas',
    bio: `Ali Wong es una comediante y actriz estadounidense que rompió barreras con su comedia audaz y sin disculpas sobre el embarazo, la maternidad, el matrimonio y la sexualidad femenina. Su revolucionario especial de Netflix "Baby Cobra", realizado cuando estaba embarazada de siete meses, se convirtió en un fenómeno cultural.\n\nNacida en San Francisco de madre vietnamita y padre chino-americano, Wong estudió Estudios Asiático-Americanos en UCLA antes de mudarse a Nueva York para dedicarse al stand-up.\n\nLa comedia de Wong es refrescantemente honesta sobre temas a menudo considerados tabú, presentada con confianza e ingenio agudo. Más allá del stand-up, ha protagonizado películas de comedia romántica, escrito un libro bestseller y creado la serie de Netflix "Beef", aclamada por la crítica.`,
    style: 'Audaz, honesta, perspectiva feminista, humor que rompe tabúes',
    achievements: [
      'Emmy Awards por Beef',
      'Golden Globe Award',
      'Autora de bestsellers del New York Times',
      'Time 100 personas más influyentes',
      'Especiales de Netflix revolucionarios',
      'Aclamación crítica por actuación y escritura',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكية',
    shortBio: 'رائدة وصريحة بلا اعتذار',
    bio: `علي ونغ كوميدية وممثلة أمريكية كسرت الحواجز بكوميديا جريئة وصريحة بلا اعتذار حول الحمل والأمومة والزواج والجنسانية الأنثوية. عرضها الخاص الرائد على Netflix "Baby Cobra" الذي أدّته وهي حامل في شهرها السابع أصبح ظاهرة ثقافية.\n\nوُلدت في سان فرانسيسكو لأم فيتنامية وأب أمريكي صيني الأصل، ودرست الدراسات الأمريكية الآسيوية في UCLA قبل الانتقال إلى نيويورك لمتابعة مسيرة الستاند أب.\n\nتتميز كوميديا ونغ بصدقها المنعش حول موضوعات كثيرًا ما تُعدّ من المحظورات، مقدَّمةً بثقة ومرح حاد. وتعدّى مسيرتها الستاند أب إلى التمثيل والتأليف وإنشاء مسلسل Netflix "Beef" الذي حصد إشادة نقدية وعدة جوائز Emmy.`,
    style: 'جريئة وصادقة، منظور نسوي، فكاهة تكسر المحظورات',
    achievements: [
      'جوائز Emmy عن Beef',
      'Golden Globe Award',
      'مؤلفة كتب من قوائم New York Times للأكثر مبيعًا',
      'قائمة Time 100 للشخصيات الأكثر تأثيرًا',
      'عروض Netflix رائدة',
      'إشادة نقدية بالتمثيل والكتابة',
    ],
  },
];
